module.exports = __webpack_public_path__ + "assets/img/kv-a3c59356.jpg";